export default __webpack_public_path__ + "images/8b038e72ee72c7ab4aee204b725ac085.png";